import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DataGrid } from "@mui/x-data-grid";
import { Stack, useMediaQuery } from "@mui/material";

const ProductDataGrid = ({
  children,
  rows,
  columns,
  onCellClick,
  sx,
  checkboxSelection,
  isDataLoading,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
      CoffeeKey: true,    // 2025-07-11 김용길 이사 요청으로 CoffeeKey 컬럼 보이도록 설정
  });
  const matches = useMediaQuery('(max-width:800px)');

  const getHeightSX = () => {
    return {
      // minHeight: 180,
      minHeight: 400,
      maxHeight: 700,
      ...sx,
    };
  };
  
  const handleDetailClick = (params) => {
    const coffeeKeyId = params.row.CoffeeKey;
    navigate(`/detail/${coffeeKeyId}`);
  };

  
  React.useEffect(() => {
    setColumnVisibilityModel({
      id: !matches,
      CoffeeKey: true,    // 2025-07-11 김용길 이사 요청으로 CoffeeKey 컬럼 보이도록 설정
      Altitude: !matches,
      ProcessingCode: !matches,
      Company: !matches,
      Farm: false,
    });
  }, [columns]);

  return (
    <Stack sx={getHeightSX}>
      <DataGrid
        autoHeight
        children={children}
        sx={sx}
        columnVisibilityModel={columnVisibilityModel}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        hideFooterSelectedRowCount={true}
        rowHeight={55}
        onCellClick={handleDetailClick}
        slotProps={{ pagination: { labelRowsPerPage: t('searchfield.rows_per_page') } }}
      />
    </Stack>
  );
};

export default ProductDataGrid;
